import { NotesBaaSignRequest } from '@ffd/api-client';

export enum BaaSignModalStep {
  AuthorizedAgreement = 'authorized-agreement',
  AuthorizedSuccess = 'authorized-success',

  NotAuthorizedSignerDetails = 'not-authorized-signer-details',
  NotAuthorizedSuccess = 'not-authorized-success',
}

export interface BaaSignModalData {
  location: 'home' | 'account' | 'recording';
  authorizedOption?: AuthorizedOption;
}

export interface BaaSignModalState {
  step: BaaSignModalStep;
  signerFullName: string;
  signerEmail: string;
  isLoading: boolean;
  isLoadingSignRequest: boolean;
  activeSignRequest: NotesBaaSignRequest | null;
}

export type AuthorizedOption = 'authorized' | 'not-authorized';
